import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconForkKnife: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconForkKnife"><Path d="M5.5 3.5V10.5L7.5 12.5V20.5H9.5V12.5L11.5 10.5V3.5M7.5 3.5V9.5M9.5 3.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 20.5V3.5C17 3.5 14.5 7.5 14 15.5H16.5V20.5H18.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconForkKnife;
